;globalThis["_sentryNextJsVersion"] = "16.1.6";import * as Sentry from '@sentry/nextjs';
import posthog from 'posthog-js';
import { browserEnvironmentFromHostname } from './lib/browserEnvironment';
import { SENTRY_DENY_URLS } from './lib/sentryDenyUrls';

// Initialize Sentry on the client
// https://docs.sentry.io/platforms/javascript/guides/nextjs/
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: false,
    dsn: 'https://211db62df5236188d8ac617d8f3bc833@o31114.ingest.us.sentry.io/4510426456784896',
    // Start at 5% tracing
    tracesSampleRate: 0.05,
    enableLogs: true,
    // Last stack frame only. Patterns live in sentryDenyUrls.ts.
    denyUrls: SENTRY_DENY_URLS,

    environment: browserEnvironmentFromHostname(window.location.hostname),
  });
}

// Initialize PostHog
posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST!,
  ui_host: process.env.NEXT_PUBLIC_POSTHOG_HOST!,
  defaults: '2025-05-24',
  capture_exceptions: false, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
  debug: false,
});

// Export the onRouterTransitionStart hook for Sentry navigation instrumentation
// https://docs.sentry.io/platforms/javascript/guides/nextjs/manual-setup/#instrument-navigations
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
